import { Menu } from 'antd';

import useLanguageSwitcher from '~/shared/components/header/components/language-switcher/use-language-switcher';
import type { Locale } from '~/universal/constants';

import './language-switcher.scss';

type LanguageSwitcherProps = Readonly<{
  lng: Locale;
}>;

const LanguageSwitcher = ({ lng }: LanguageSwitcherProps) => {
  const { menuItems } = useLanguageSwitcher({
    lng,
  });

  return (
    <div className="language-switcher__wrapper">
      <div className="language-switcher">
        <Menu disabledOverflow mode="horizontal" theme="dark" items={menuItems} />
      </div>
    </div>
  );
};

export default LanguageSwitcher;
